import {useEffect, useState} from "react";
import {animated, useSpring} from "@react-spring/web";
import styles from "../marketing.module.scss";
import arrow_white from "../../../../resources/img/Events/Marketing/arrow_white.png";
import sec02_alphabet01_m from '../../../../resources/img/Events/Marketing/sec02_alphabet01_m.png';
import sec02_alphabet02_m from '../../../../resources/img/Events/Marketing/sec02_alphabet02_m.png';
import sec02_bg_dot_m from '../../../../resources/img/Events/Marketing/sec02_bg_dot_m.png';

export const Section02 = (props) => {
    const [frame, setFrame] = useState(0)
    const spring = useSpring({ x: frame })

    useEffect(() => {
        if (!props.ranges?.length || props.ranges[0].length < 2) return
        const currentFrame = props.run(props)
        // console.log(currentFrame)
        setFrame(currentFrame)
    }, [props.pageYOffset, props.innerHeight])

    return (
        <animated.div className={styles['animation-container']} style={{
            opacity: spring.x.to({
                range: props.section.opacityRange as number[],
                output: props.section.opacityOutput as number[]
            }).to(x => x),
        }}>
            <div className={`${styles.sec} ${styles.sec02} ${styles.rel}`}>
                <animated.p className={`${styles.sec02__font01} ${styles.ab} ${styles.marginDel}`} style={{
                    opacity: spring.x.to({
                        range: [0, 0.25, 0.45, 1],
                        output: [0, 0, 1, 1]
                    }).to(x => x),
                    scale: spring.x.to({
                        range: [0, 0.25, 0.45, 1],
                        output: [0.8, 0.8, 1, 1]
                    }).to(x => x),
                    translateY: spring.x.to({
                        range: [0, 0.25, 0.45, 0.85, 1],
                        output: [0, 0, 3, 3, -15]
                    }).to(x => `${x}vh`)
                }}>빗썸이</animated.p>
                <animated.p className={`${styles.sec02__font02} ${styles.ab} ${styles.notoBold} ${styles.marginDel} ${props.play && styles['sec02__font02--show']}`} style={{
                    translateY: spring.x.to({
                        range: [0, 0.2, 0.45, 0.85, 1],
                        output: [0, 0, 3, 3, -15]
                    }).to(x => `${x}vh`)
                }}>확 바꿨습니다</animated.p>
                <span className={`${styles.sec02__circle01} ${styles.ab}`}></span>
                <span className={`${styles.sec02__circle02} ${styles.ab}`}></span>
                <animated.img className={`${styles.sec02__img01} ${styles.ab}`} src={sec02_alphabet01_m} alt="알파벳 묶음1" style={{
                    translateY: spring.x.to({
                        range: [0, 0.85, 1],
                        output: [0, 0, 30]
                    }).to(x => `${x}vh`)
                }} />
                <animated.img className={`${styles.sec02__img02} ${styles.ab}`} src={sec02_alphabet02_m} alt="알파벳 묶음2" style={{
                    translateY: spring.x.to({
                        range: [0, 0.85, 1],
                        output: [0, 0, -30]
                    }).to(x => `${x}vh`)
                }} />
                <img className={`${styles.sec02_bg_dot} ${styles.ab}`} src={sec02_bg_dot_m} alt="배경 점" />
                <img className={`${styles.sec02__arrow} ${styles.ab}`} src={arrow_white} alt="아래방향 화살표" />
            </div>
        </animated.div>
    )
}